import {Column, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn} from 'typeorm';
 
@Entity('types_of_leaves')
export class TypesOfLeaves{

    @PrimaryGeneratedColumn('increment', {name: 'type_of_leave_id'})
    typeOfLeaveId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'type_of_leave'
    })
    typeOfLeave: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'leave_code'
    })
    leaveCode: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'default_leaves'
    })
    defaultLeaves: number;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}